import { render } from "./LegacyEmailTrigger.vue?vue&type=template&id=92b23382"
import script from "./LegacyEmailTrigger.vue?vue&type=script&lang=js"
export * from "./LegacyEmailTrigger.vue?vue&type=script&lang=js"
script.render = render

export default script